import React from "react";
import "../NewLanding.css";
import "./previewScope.css";

/** Wraps research/debate previews with NewLanding product UI tokens + styles. */
export default function ProductPreviewShell({ children, className = "" }) {
  return (
    <div className={`nl-preview-scope${className ? ` ${className}` : ""}`}>
      {children}
    </div>
  );
}
